export interface StackItemBase {
  id: string;
  name: string;
  categoryKey: string;
  color?: string;
}

export const STACK_ITEMS_BASE: StackItemBase[] = [
  // Backend & Runtimes
  { id: 'node', name: 'NESTJS & NODE.JS', categoryKey: 'Backend & Runtimes', color: '#00F0FF' },
  { id: 'bun-elysia', name: 'BUN & ELYSIA.JS', categoryKey: 'Backend & Runtimes', color: '#00F0FF' },
  { id: 'ts-js', name: 'TYPESCRIPT & JS (ES6+)', categoryKey: 'Backend & Runtimes', color: '#00F0FF' },

  // Realtime & Architecture
  { id: 'webrtc-ws', name: 'WEBRTC & LIVEKIT', categoryKey: 'Realtime & Architecture', color: '#00F0FF' },
  { id: 'api', name: 'REST APIS & EVENTS', categoryKey: 'Realtime & Architecture', color: '#00F0FF' },
  { id: 'clean-tdd-ddd', name: 'CLEAN CODE, TDD & DDD', categoryKey: 'Realtime & Architecture', color: '#00F0FF' },

  // Frontend & Mobile
  { id: 'react-vue', name: 'REACT.JS & VUE.JS', categoryKey: 'Frontend & Mobile', color: '#00F0FF' },
  { id: 'angular', name: 'ANGULAR & ENTERPRISE', categoryKey: 'Frontend & Mobile', color: '#00F0FF' },
  { id: 'rn-expo', name: 'REACT NATIVE & EXPO', categoryKey: 'Frontend & Mobile', color: '#00F0FF' },
  { id: 'styling', name: 'TAILWIND & UI SYSTEMS', categoryKey: 'Frontend & Mobile', color: '#00F0FF' },

  // Databases & ORMs
  { id: 'mysql-postgres', name: 'MYSQL & POSTGRESQL', categoryKey: 'Databases & ORMs', color: '#00F0FF' },
  { id: 'drizzle-prisma', name: 'DRIZZLE & PRISMA ORM', categoryKey: 'Databases & ORMs', color: '#00F0FF' }
];

export interface ProjectItemBase {
  id: string;
  tags: string[];
  link: string;
  featured?: boolean;
  type?: 'mobile' | 'web' | 'backend';
  links?: {
    website?: string;
    appStore?: string;
    playStore?: string;
  };
  media?: {
    type: 'image' | 'video';
    src?: string;
    poster?: string;
  };
}

export const PROJECT_ITEMS_BASE: ProjectItemBase[] = [
  {
    id: '01',
    featured: true,
    type: 'mobile',
    tags: ['Expo SDK 57', 'React Native', 'Expo Router', 'StyleSheet', 'Apple Liquid Glass', 'EAS Build', 'Offline-First'],
    link: 'https://apps.apple.com/br/app/executive-jiujitsu/id6806416138?l=en-GB',
    links: {
      appStore: 'https://apps.apple.com/br/app/executive-jiujitsu/id6806416138?l=en-GB',
      playStore: 'https://play.google.com/store/apps/details?id=dev.yata.executivejiujitsu'
    },
    media: {
      type: 'video',
      src: '/assets/projects/executive-jj-demo.mp4',
      poster: '/assets/projects/executive-jj-poster.jpg'
    }
  },
  {
    id: '02',
    tags: ['WebRTC', 'LiveKit', 'WebSockets', 'Node.js', 'Bun', 'TypeScript'],
    link: 'https://github.com/luanyata'
  },
  {
    id: '03',
    tags: ['Bun', 'Elysia.js', 'Drizzle ORM', 'Monorepo', 'TypeScript', 'MySQL'],
    link: 'https://medium.com/@luanyata'
  },
  {
    id: '04',
    tags: ['NestJS', 'Node.js', 'DDD', 'TDD', 'Clean Arch', 'React', 'PostgreSQL'],
    link: 'https://github.com/luanyata'
  }
];
